<template>
  <div class="slides-wrapper">
    <Header></Header>
    <Slide1 v-show="isVisibleSlide(1)" @changeSlide="changeSlide" @stationSelected="setStationFrom"></Slide1>
    <Slide2 v-show="isVisibleSlide(2)" @changeSlide="changeSlide" :talkLondon="talkLondon" :stationFrom="stationFrom" @stationSelected="setStationTo"></Slide2>
    <Slide4 v-show="isVisibleSlide(4)" @changeSlide="changeSlide"></Slide4>
    <Slide5 v-show="isVisibleSlide(5)" @changeSlide="changeSlide"></Slide5>
    <Slide6 v-show="isVisibleSlide(6)" @changeSlide="changeSlide" :sameJourneys="sameJourneys" :shares="shares" :stationFrom="stationFrom" :stationTo="stationTo"></Slide6>
    <Slide7 v-show="isVisibleSlide(7)" @changeSlide="changeSlide" @shared="setShared" :facebook="facebook" :facebookPrivate="facebookPrivate" :sameJourneys="sameJourneys" :stationFrom="stationFrom" :stationTo="stationTo"></Slide7>
    <Slide8 v-show="isVisibleSlide(8)" @changeSlide="changeSlide" :shared="shared" :talkLondon="talkLondon"></Slide8>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Slide1 from './components/Slide1.vue';
import Slide2 from './components/Slide2.vue';
import Slide4 from './components/Slide4.vue';
import Slide5 from './components/Slide5.vue';
import Slide6 from './components/Slide6.vue';
import Slide7 from './components/Slide7.vue';
import Slide8 from './components/Slide8.vue';

export default {
  name: 'app',
  components: { Header, Slide1, Slide2, Slide4, Slide5, Slide6, Slide7, Slide8 },

  data() {
    return {
      visibleSlides: [1],
      shared: false,
      stationFrom: {id: null, name: ''},
      stationTo: {id: null, name: ''},
      stationsIntermediate: [],
      sameJourneys: 1,
      shareImage: null,
      shares: {
        recentShares: 0,
        allShares: 0
      },
    }
  },

  computed: {
    talkLondon() {
      return this.getParameterByName('tl') ? false : false;
    },

    facebook() {
      let descriptionPrefix = this.sameJourneys > 9 ? Number(this.sameJourneys).toLocaleString() : 'Fewer than 10'
      return {
        title: 'How many Londoners do your Tube journey every day?',
        description: `${descriptionPrefix} people take the Tube from ${this.stationFrom.name} to ${this.stationTo.name} every day.<br> How many do your Tube journey?`,
        image:  this.shareImage
      }
    },

    facebookPrivate() {
      let descriptionPrefix = this.sameJourneys > 9 ? Number(this.sameJourneys).toLocaleString() : 'Fewer than 10'
      return {
        title: `${descriptionPrefix} Londoners do the same journey as me every day`,
        description: 'How many Londoners start and end their journey at the same stations as you?',
        image: 'https://gla-your-commute-2.appspot.com/static/new.png'
      }
    }
  },

  methods: {
    changeSlide(i) {
      if (!this.isVisibleSlide(i)) {
        this.visibleSlides.push(i);
      }

      if (! window.journeyScrolling) {
        setTimeout(() => {
          let offset = window.innerWidth > 767 ? 0 : -65;
          this.$scrollTo('#slide-' + i, 800, { offset });
        }, 100);
      }
    },

    isVisibleSlide(i) {
      return this.visibleSlides.indexOf(i) !== -1;
    },

    setShared() {
      this.shared = true;
    },

    setStationFrom(station) {
      this.stationFrom = station;
      this.getSameJourneys();
    },

    setStationTo(station) {
      this.stationTo = station;
      this.getSameJourneys();
    },

    setStationsIntermediate(stations) {
      this.stationsIntermediate = stations;
    },

    getSameJourneys() {
      if (this.stationFrom.id && this.stationTo.id) {
        let from = this.stationFrom.id;
        let to = this.stationTo.id;
        axios.get('journeys.php', {
          params: {
            from: from,
            to: to
          }
        }).then(response => {
          this.sameJourneys = Number(response.data.journeys);
          //this.getShareImage();
        });
      }
    },

    getShareImage() {
      var data = {
        journeys: this.sameJourneys,
        from: this.stationFrom,
        to: this.stationTo
      }

      axios.post('makeImage.php', JSON.stringify(data))
              .then(response =>  {
                this.shareImage = 'https://storage.googleapis.com/gla-your-commute-2.appspot.com/'+response.data.shareImage;
              })
              .catch(err => console.log(err));
    },

    getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  },

  beforeCreate() {
    axios.get('shareCounter.php')
        .then(response => {
          this.shares.recentShares = Number(response.data.recent_shares);
          this.shares.allShares = Number(response.data.all_shares);
        });
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue